<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
